import { useState, useEffect, useContext } from "react";
import Instance from "../../Services/Instance";
import config from "../../Services/config.js";
import SideBar from "../../Layouts/SideBar";
import "../../Assets/Styles/Products.css";
import AddCategoryOrProduct from "./AddCategoryOrProduct.js";
import { DataContext } from '../../Services/DataContext.js';

function NewProduct() {
    const [error, setError] = useState("");
    const [newProduct, setNewProduct] = useState({
        productCategory: "",
        productName: "",
        productType: "",
        productImage: null,
        productDescription: "",
        productPrice: "",
        productPrice2: "",
        productAttention: "",
        points: "",
        productTerme: "",
        faq: [{ question: "", answer: "" }],
        bamboo: {
            enabled: false,
            id: "",
            name: "",
            brand: "",
            currencyCode: "",
            countryCode: "",
            price: "",
            domination: ""
        }
    });


    const { categories } = useContext(DataContext);
    const { productCategory, productName, productType, productImage, productDescription, productTerme, productPrice, productPrice2, productAttention, points, faq } = newProduct;

    const onInputChange = (e) => {
        setNewProduct({ ...newProduct, [e.target.name]: e.target.value });
    };

    const onImageChange = (e) => {
        setNewProduct({ ...newProduct, productImage: e.target.files[0] });
    };

    const handleFaqChange = (index, fieldName, value) => {
        const updatedFaqs = [...newProduct.faq];
        updatedFaqs[index][fieldName] = value;
        setNewProduct({ ...newProduct, faq: updatedFaqs });
    };

    const addFaq = () => {
        setNewProduct({ ...newProduct, faq: [...faq, { question: "", answer: "" }] });
    };

    const onBambooChange = (e) => {
        const { name, value, type, checked } = e.target;

        setNewProduct({
            ...newProduct,
            bamboo: {
                ...newProduct.bamboo,
                [name]: type === "checkbox" ? checked : value
            }
        });
    };


    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const formData = new FormData();
            formData.append('productCategory', productCategory);
            formData.append('productName', productName);
            formData.append('productType', productType);
            formData.append('productImage', productImage);
            formData.append('productDescription', productDescription);
            formData.append('productTerme', productTerme);
            formData.append('productPrice', parseFloat(productPrice) || 0);
            formData.append('productPrice2', parseFloat(productPrice2) || 0);
            formData.append('points', parseFloat(points) || 0);
            formData.append('productAttention', productAttention);

            faq.forEach((_faq, index) => {
                formData.append(`faq[${index}][question]`, _faq.question);
                formData.append(`faq[${index}][answer]`, _faq.answer);
            });

            // ✅ BAMBOO
            formData.append("bamboo[enabled]", newProduct.bamboo.enabled);
            formData.append("bamboo[id]", newProduct.bamboo.id);
            formData.append("bamboo[name]", newProduct.bamboo.name);
            formData.append("bamboo[brand]", newProduct.bamboo.brand);
            formData.append("bamboo[currencyCode]", newProduct.bamboo.currencyCode);
            formData.append("bamboo[countryCode]", newProduct.bamboo.countryCode);
            formData.append("bamboo[price]", parseFloat(newProduct.bamboo.price) || 0);
            formData.append("bamboo[domination]", parseFloat(newProduct.bamboo.domination) || 0);


            // Log formData entries for debugging
            for (let [key, value] of formData.entries()) {
                // console.log(key, value);
            }

            await Instance.post(`${config.api_url}/new--product`, formData);
            window.location = "/dashboard/product";
        } catch (error) {
            console.error("Error during submission:", error);
            setError(error);
        }
    };

    return (
        <div className='a-new-product'>
            <SideBar />
            <div className="parent-new-product">
                <div className="new-category">
                    <AddCategoryOrProduct />
                </div>
                <form onSubmit={handleSubmit} className="new-product" encType="multipart/form-data">
                    <h1>Ajout d'un nouveau produit</h1>
                    <div className="form-display">
                        <div>
                            <label>Category:</label>
                            <select
                                value={productCategory}
                                name="productCategory"
                                onChange={onInputChange}
                                required
                            >
                                <option value="">Select a Category</option>
                                {categories && categories.map((item, index) => (
                                    <option key={index} value={item.categoryName}>{item.categoryName}</option>
                                ))}
                            </select>
                        </div>

                        <div>
                            <label>Product:</label>
                            <input
                                list="productName-suggestions"
                                value={productName}
                                name="productName"
                                onChange={onInputChange}
                                required
                                disabled={!productCategory}
                                placeholder="Tapez ou sélectionnez un produit"
                                autoComplete="off"
                            />
                            <datalist id="productName-suggestions">
                                {productCategory &&
                                    categories
                                        .find((item) => item.categoryName === productCategory)
                                        ?.productsName?.map((product, index) => (
                                            <option key={index} value={product} />
                                        ))}
                            </datalist>
                        </div>
                        <div>
                            <label htmlFor="productType">Product Type</label>
                            <input
                                className="input"
                                value={productType}
                                name="productType"
                                type="text"
                                onChange={onInputChange}
                                required
                            />
                        </div>

                        <div>
                            <label htmlFor="productImage">Product Image</label>
                            <input
                                className="input"
                                type="file"
                                name="productImage"
                                onChange={onImageChange}
                                required
                            />
                        </div>

                        <div>
                            <label htmlFor="productPrice">Product Price</label>
                            <input
                                className="input"
                                value={productPrice}
                                name="productPrice"
                                type="text"
                                onChange={onInputChange}
                                required
                            />
                        </div>

                        {/*<div>
                            <label htmlFor="points">Points pour ce produit</label>
                            <input
                                className="input"
                                value={points}
                                name="points"
                                type="number"
                                onChange={onInputChange}
                                required
                            />
                        </div> */}

                        {productName.toLocaleLowerCase().includes("netflix") && (
                            <div>
                                <label htmlFor="productPrice2">Prix Smart TV </label>
                                <input
                                    className="input"
                                    value={productPrice2}
                                    name="productPrice2"
                                    type="text"
                                    onChange={onInputChange}
                                />
                            </div>
                        )}

                        <div id="description">
                            <label htmlFor="productDescription">Product Description</label>
                            <textarea
                                className="input"
                                value={productDescription}
                                name="productDescription"
                                onChange={onInputChange}
                                required
                            />
                        </div>
                        <div id="description">
                            <label htmlFor="productDescription">Terme ou Policy</label>
                            <textarea
                                className="input"
                                value={productTerme}
                                name="productTerme"
                                onChange={onInputChange}
                            />
                        </div>
                        <div id="description">
                            <label htmlFor="productDescription">Text d'avertisement</label>
                            <textarea
                                className="input"
                                value={productAttention}
                                name="productAttention"
                                onChange={onInputChange}
                            />
                        </div>

                        <hr />
                        <h3>Intégration Bamboo</h3>

                        <div>
                            <label>
                                <input
                                    type="checkbox"
                                    name="enabled"
                                    checked={newProduct.bamboo.enabled}
                                    onChange={onBambooChange}
                                />
                                Activer Bamboo
                            </label>
                        </div>

                        {newProduct.bamboo.enabled && (
                            <>
                                <div>
                                    <label>Bamboo ID</label>
                                    <input
                                        type="number"
                                        name="id"
                                        value={newProduct.bamboo.id}
                                        onChange={onBambooChange}
                                    />
                                </div>

                                <div>
                                    <label>Nom Bamboo</label>
                                    <input
                                        type="text"
                                        name="name"
                                        value={newProduct.bamboo.name}
                                        onChange={onBambooChange}
                                    />
                                </div>

                                <div>
                                    <label>Marque</label>
                                    <input
                                        type="text"
                                        name="brand"
                                        placeholder="Apple / Playstation"
                                        value={newProduct.bamboo.brand}
                                        onChange={onBambooChange}
                                    />
                                </div>

                                <div>
                                    <label>Devise</label>
                                    <input
                                        type="text"
                                        name="currencyCode"
                                        placeholder="EUR"
                                        value={newProduct.bamboo.currencyCode}
                                        onChange={onBambooChange}
                                    />
                                </div>

                                <div>
                                    <label>Pays</label>
                                    <input
                                        type="text"
                                        name="countryCode"
                                        placeholder="FR"
                                        value={newProduct.bamboo.countryCode}
                                        onChange={onBambooChange}
                                    />
                                </div>

                                <div>
                                    <label>Prix Bamboo</label>
                                    <input
                                        type="number"
                                        name="price"
                                        value={newProduct.bamboo.price}
                                        onChange={onBambooChange}
                                    />
                                </div>

                                <div>
                                    <label>Domination</label>
                                    <input
                                        type="number"
                                        name="domination"
                                        value={newProduct.bamboo.domination}
                                        onChange={onBambooChange}
                                    />
                                </div>
                            </>
                        )}
                    </div>


                    <div className="faq-new-product">
                        <h1>FAQs</h1>
                        {faq.map((faq_, index) => (
                            <div key={index} className="faq-content">
                                <h4>{`FAQ ${index + 1}`}</h4>
                                <div>
                                    <label htmlFor={`question-${index}`}>{`Question ${index + 1}:`}</label>
                                    <input
                                        type="text"
                                        id={`question-${index}`}
                                        value={faq_.question}
                                        onChange={(e) => handleFaqChange(index, 'question', e.target.value)}
                                    />
                                </div>
                                <div id="description">
                                    <label htmlFor={`answer-${index}`}>{`Answer ${index + 1}:`}</label>
                                    <textarea
                                        id={`answer-${index}`}
                                        value={faq_.answer}
                                        onChange={(e) => handleFaqChange(index, 'answer', e.target.value)}
                                    />
                                </div>
                            </div>
                        ))}
                        <div>
                            <button className="more-faq" type="button" onClick={addFaq}>Plus de FAQs</button>
                        </div>
                    </div>
                    <div className="validate">
                        <button type="submit" className="add-new-element">Add</button>
                    </div>
                </form>
            </div>
            {error && (
                <h1 style={{ color: "red", position: "fixed", left: "10%", bottom: "10%" }}>
                    {error.response?.data?.message || "An error occurred"}
                </h1>
            )}
        </div>
    );
}

export default NewProduct;
